import { ItalicOutlined } from '@ant-design/icons'
import { Flex } from 'antd'

import { BasicProps } from '@eastcoal/common/types/component'

import { useSelectionTextFormat } from '../../hooks/useSelectionTextFormat'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { MenuButton } from '../../ui/MenuButton'

export const ItalicButton = (props: BasicProps) => {
  const [italic, toggleItalic] = useSelectionTextFormat('italic')

  return (
    <MenuButton
      {...props}
      actived={italic}
      tooltip={
        <Flex vertical align='center'>
          <span>斜体</span>
          <span>{SHORTCUTS.ITALIC}</span>
        </Flex>
      }
      onClick={toggleItalic}
    >
      <ItalicOutlined />
    </MenuButton>
  )
}
